import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0104 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="サービス残業とは？その問題点と対策について解説！" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2026.06.24</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        働き方改革施行後、様々な働き方がクローズアップされています。他方、働き方が多様化するということは、それに伴い労務管理も多様化しなければなりませんが、働き方の多様化に対して労務管理が追い付いていないといったケースが少なくありません。その中の一つの負の側面として、サービス残業が発生してしまっているというケースです。今回はサービス残業の問題や発生してしまう要因について解説します。
      </p>
      <img src="/images/column/details/c0104.jpg" alt="キンクラコラム画像104" />
      <div id="toc1">
        <h1>サービス残業とは</h1>
      </div>
      <p>
        <span>
          実質的に労務提供しているにも関わらず、労働していないと偽り、賃金が発生しないとすること
        </span>
        で、言うまでもなく、本来はあってはならないことです。サービス残業は非常に根深く、２つの側面があります。１つは上長より圧力を用いてサービス残業を強いるケースです。２つ目は労働者の感覚が麻痺しているがゆえにサービス残業になってしまっているケースです。
        <br />
        <br />
        １つ目の問題が起こる背景として、
        <span>
          社内で締結している36協定の時間外労働時間数を遵守するために、特定の労働者に対して締結している時間に近づいた場合にサービス残業を強いているといったケースが考えられます
        </span>
        。これは36協定に関わらず、社内で時間外労働時間数●時間以内といった目標を掲げている場合に、当該目標を達成するために不適切な指示をするといったケースも考えられます。
        <br />
        <br />
        2つ目の問題は、1つ目の状態やそもそもサービス残業という自覚がなく、サービス残業が日常的となってしまっていることから、上長から特段の指示がなくとも労働者の自覚がないままサービス残業を行っているといったケースです。2つ目の問題は非常に危険な側面を孕んでおり、上長の監視も行き届いていないことが多く、過労による健康被害も想定されるため、注意が必要です。
      </p>

      <div id="toc2">
        <h1>サービス残業の事例や要因</h1>
      </div>
      <p>
        サービス残業の事例として、
        <span>
          勤怠記録上は所定労働時間を超えて残っているにも関わらず当該時間は労働時間ではなく、業務とは直接的な因果関係のない単なる自己研鑽として残業申請すら行わない
        </span>
        ために、社内にサービス残業が当たり前の雰囲気になっていくことです。サービス残業が徐々に広まっていく要因として、
        <span>
          1つのサービス残業の発生事例が徐々に積み重なっていくことで、次第に労働者自身が残業申請することが難しい雰囲気が醸成されていくことから、問題が大きくなる傾向にあります
        </span>
        。これはいわゆる「前残業」の場合も同趣旨で、所定労働時間内では到底終えることが困難な業務量を課されており、終業時刻後は家庭の事情（例えば子の養育）により残業することが困難な場合、
        <span>始業時刻前のサービス残業も発生すること</span>
        が考えられます。
        <br />
        <br />
        また、サービス残業の他の側面として、持ち帰り残業もあります。前述の子の養育のために、退社せざるを得ないものの、業務の納期を守るために、やむを得ず持ち帰り残業をするケースですが、当然、褒められる状態ではありません。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc3">
        <h1>違法となる理由</h1>
      </div>
      <p>
        そもそも「労働時間」とは、
        <span>
          使用者からの指揮命令下に置かれた時間と解されることから、始業時刻前、終業時刻後であっても指揮命令が介在することで当該時間は労働時間
        </span>
        となり得ます。言い換えると、所定労働時間内のみの指揮命令であれば理論上、残業そのものは発生しませんが、所定労働時間外に指揮命令があった場合はもちろん、物理的に始業時刻前、終業時刻後も業務を行わなければ到底業務の完遂が困難な場合も労働時間と評価されることがあるため、注意が必要です。
      </p>

      <div id="toc4">
        <h1>サービス残業を減らす対策など</h1>
      </div>
      <p>
        まずは
        <span>会社のトップからの意思表明</span>
        です。仮に退職時にサービス残業代を一括請求された場合、
        <span>
          現時点では法律上最大3年まで遡及して請求が可能であるため、人によって差はあるものの、相当な額になることもあり得る
        </span>
        ことから、経営的にも大きなリスクを孕んでいます。また、トップからの意思表明は一時的な単なる抑止力で終わってしまうこともあるため、実際の現場に近い中間管理職等の
        <span>定期的なチェックが必要です</span>
        。特にサービス残業という自覚がない労働者の場合、そもそも中間管理職自身がそのような状況を全く認識できていないケースがあるだけでなく、中間管理職が割り振った仕事の分配が適正でないこともあります。当然、仕事の分配が適正でなければ、生産性の上がる機器の導入や、当該労働者の能力のアップがない限り、根本的な解決になりません。この問題いついては中間管理職の意識を変えるのみでは解決に至らず、
        <span>
          労働者に対してもサービス残業が慢性化することで他の労働者にも負の影響が及ぶこと、仕事は単発ではなく、長期的なものであるため、健康確保にも注力することの重要性を認識してもらうことが重要
        </span>
        です。
      </p>

      <div id="toc5">
        <h1>最後に</h1>
      </div>
      <p>
        サービス残業は在籍する労働者の士気が低下するだけでなく、風評によって会社のイメージの低下にもつながります。サービス残業は違法という認識をもっていながらも解決に至らないといった場合は使用者側だけでなく、労働者側も交えて認識を改めていく必要があります。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0104
